import db from 'database';
import Helpers from 'shared/helpers';
import moment from 'moment';

export default class Sync {
  _id;
  pems;
  perguntas;
  fases;
  dadosIniciais;
  cidades;
  estados;
  culturas;
  respostas;
  updatedAt;

  /**
   *
   * @param {Object} data
   * @param {Number} data.id
   * @param {Date} data.pems
   * @param {Date} data.perguntas
   * @param {Date} data.fases
   * @param {Date} data.dadosInicias
   * @param {Date} data.cidades
   * @param {Date} data.estados
   * @param {Date} data.culturas
   * @param {Date} data.respostas
   * @param {String} [data.createdAt]
   * @param {String} [data.updatedAt]
   * @param {String} [data.deletedAt]
   */
  constructor(data) {
    Helpers.constructModel(data, this);
  }

  save() {
    this.updatedAt = moment()
      .toDate()
      .toISOString();
    return db.sync.put(this);
  }

  static describe = () => '++_id, produtos, pems, perguntas, fases, dadosIniciais, cidades, estados, culturas, respostas, createdAt, updatedAt, deletedAt';
}
